module.exports = __webpack_public_path__ + "img/MOBILE.8c3fc5dc.svg";